import React, { Component } from 'react';
import './notice_dialog.less';
import styles from './notice_dialog.less';

export default class NoticeDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: true,
			config: {},  //drop内容位置，大小，是否可滚动等等
			top: 120,
			maxHeight: 20000,
		}
		window.addEventListener('resize', (ev) => {
			this.setState({
				maxHeight: window.innerHeight - this.state.top,
			});
		});
	}
	componentDidMount() {
		this.setState({
			maxHeight: window.innerHeight - this.state.top,
		});
	}
	/**
	 * 设置通知是否可见
	 * @param visible 是否可见
	 */
	setIsVisible(visible) {
		this.setState({
			isVisible: visible
		});
	}
	render() {
		let show = this.props.show && this.state.isVisible;
		let style = {
			top: this.state.top + 'px',
			maxHeight: this.state.maxHeight + 'px',
		};
		if (!show) {
			style.display = 'none';
		}
		return <div id='notice-dialog' className={'notice-dialog ' + styles['notice-dialog']}
			style={style}
		>
			<div id='content' className={'content ' + styles['content']}>
				{this.props.children}
			</div>
		</div>;
	}
}